<div class="header">
  <nav>
    <div class="pull-right mr-4 mt-3">
      <a class="mt-3 mx-2 border rounded border-primary p-2"
         style="text-decoration: none;cursor: pointer;"
         routerLink="categories"
         *hasPermission="['services-category:view']">
        <ezy-icons src="/assets/icons/list-ui-alt.svg"></ezy-icons>
        Manage Categories
      </a>
      <a class="mt-3 mx-2 border rounded border-primary p-2"
         routerLink="/services/service-providers"
         *hasPermission="['service-provider.view']"
         style="text-decoration: none;cursor: pointer;">
        <ezy-icons src="/assets/icons/user-arrows.svg"></ezy-icons>
        Manage Suppliers
      </a>
    </div>
    <ol class="breadcrumb mr-auto">
      <li class="breadcrumb-item"
          aria-current="page">App content</li>
      <li class="breadcrumb-item"
          *hasPermission="['services.view']">
        <a routerLink="/services">Services</a>
      </li>
      <li class="breadcrumb-item"
          *hasPermission="['services.edit']">
        Details
      </li>
    </ol>
  </nav>
  <hr />
</div>
<div class="px-3">
  <h3>{{service?service.name:"New Service"}}</h3>
  <div class="tabs">
    <a class="tab-link"
       routerLinkActive="active"
       routerLink="overview">Overview</a>
    <a class="tab-link"
       routerLinkActive="active"
       routerLink="pricing">Pricing</a>
    <a class="tab-link"
       routerLinkActive="active"
       *hasPermission="['services:view_service_scoping']"
       routerLink="scope">Service Scope</a>
    <a class="tab-link"
       routerLinkActive="active"
       *hasPermission="['services:edit_service_transport']"
       routerLink="transport">Transport</a>
  </div>
  <router-outlet></router-outlet>
</div>
